var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRoleIcon = function SvgRoleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#D8D8D8",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19a3 3 0 0 1 3 3v4h-9v-4a3 3 0 0 1 3-3h3Zm7-3a3 3 0 0 1 3 3v4h-6v-1a4.002 4.002 0 0 0-2.88-3.841A3 3 0 0 1 20 16h3Zm-8.5-4a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm7-3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z",
    fill: "#000"
  }))));
};
export default SvgRoleIcon;